export enum AnimationType {
    NONE = 'NONE',
    SLIDE_IN_LEFT = 'slideInLeft',
    SLIDE_IN_RIGHT = 'slideInRight',
    SLIDE_IN_TOP = 'slideInTop',
    SLIDE_IN_BOTTOM = 'slideInBottom',
    SLIDE_OUT_LEFT = 'slideOutLeft',
    SLIDE_OUT_RIGHT = 'slideOutRight',
    SLIDE_OUT_TOP = 'slideOutTop',
    SLIDE_OUT_BOTTOM = 'slideOutBottom',
}
